import 'vuetify/src/components/VDataTable/VSimpleTable.sass';
import { convertToUnit } from 'vuetify/lib/util/helpers';
import Themeable from 'vuetify/lib/mixins/themeable';
import mixins from 'vuetify/lib/util/mixins'; // Utiltiies
import TreeGridTable from './TreeGridTable.vue';

export default mixins(Themeable).extend({
  name: 'TreeGrid',
  components: {
    TreeGridTable,
  },
  props: {
    dense: Boolean,
    fixedHeader: Boolean,
    height: [Number, String],
    columns: Array,
    tree: Array,
    searchQuery: String,
    childrenProperty: String,
    emptyText: String,
    rowClass: Function,
  },

  data: () => ({}),

  computed: {
    classes() {
      return {
        'v-data-table--dense': this.dense,
        'v-data-table--fixed-height': !!this.height && !this.fixedHeader,
        'v-data-table--fixed-header': this.fixedHeader,
        ...this.themeClasses,
      };
    },
  },

  methods: {
    getClasses() {
      return {
        class: this.classes,
      };
    },
    getScopedSlots(filter) {
      return Object.keys(this.$scopedSlots)
        .filter(name => filter(name))
        .reduce((acc, name) => {
          acc[name] = this.$scopedSlots[name];
          return acc;
        }, {});
    },
    onCheck(checkedRows) {
      this.$emit('check', checkedRows);
    },
    onExpand(row) {
      this.$emit('expand', row);
    },
    onPreExpand(row) {
      this.$emit('preExpand', row);
    },
    onAdd(row) {
      this.$emit('add', row);
    },
    getTable() {
      return this.$createElement('TreeGridTable', {
        ref: 'treeGridTable',
        props: {
          columns: this.columns,
          tree: this.tree,
          searchQuery: this.searchQuery,
          childrenProperty: this.childrenProperty,
          emptyText: this.emptyText,
          rowClass: this.rowClass,
        },
        on: {
          check: this.onCheck,
          expand: this.onExpand,
          preExpand: this.onPreExpand,
          add: this.onAdd,
        },
        scopedSlots: this.getScopedSlots(name => name.startsWith('cell.') || name.startsWith('head.')),
      });
    },
    getWrapper() {
      return (
        this.$slots.wrapper ||
        this.$createElement(
          'div',
          {
            staticClass: 'v-data-table__wrapper',
            style: {
              height: convertToUnit(this.height),
            },
          },
          Object.prototype.hasOwnProperty.call(this.$scopedSlots, 'top') ? [this.$scopedSlots.top(), this.getTable()] : [this.getTable()],
        )
      );
    },
  },

  render(h) {
    return h(
      'div',
      {
        staticClass: 'v-data-table',
        class: this.classes,
      },
      [this.getWrapper()],
    );
  },
});
